import { Pivot, PivotItem } from '@fluentui/react';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Color } from '../../const/Const';
import Employees from '../..//page/HRSuite/Employees/Employees';
import Structure from '../../page/HRSuite/Structure/Structure';

const HRSuite = (props) => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const onLinkClick = (pTab) => {
        navigate('/hrsuite?tab=' + pTab?.props?.itemKey);
    }

    return (
        <Pivot
            selectedKey={searchParams.get("tab") ? searchParams.get("tab") : "0"}
            styles={{
                linkIsSelected: {
                    '&::before': {
                        backgroundColor: Color.primary
                    }
                },
                root: {
                    paddingLeft: 7,
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15), inset 0px -1px 0px rgba(217, 217, 217, 0.25)'
                }
            }}
            onLinkClick={onLinkClick}
        >
            <PivotItem headerText='Ажилтан' itemKey='employee'>
                <Employees />
            </PivotItem>
            <PivotItem headerText='Бүтэц' itemKey='structure'>
                <Structure />
            </PivotItem>
        </Pivot>
    );
}

export default HRSuite;